var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodataimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.2369 66.3589L82.0451 86.1517C83.1769 87.2828 85.017 87.2828 86.1489 86.1517C87.2837 85.0207 87.2837 83.1821 86.1489 82.0511L66.3465 62.2611C72.0263 55.6606 75.4597 47.0794 75.4597 37.7006C75.4597 16.8928 58.5539 0 37.7299 0C16.9059 0 0 16.8928 0 37.7006C0 58.5085 16.9059 75.4013 37.7299 75.4013C47.0811 75.4013 55.64 71.9966 62.2369 66.3589ZM37.5906 55.1009C39.5931 55.1009 41.2184 56.7249 41.2184 58.726C41.2184 60.727 39.5931 62.351 37.5906 62.351C35.588 62.351 33.9627 60.727 33.9627 58.726C33.9627 56.7249 35.588 55.1009 37.5906 55.1009ZM34.6825 17.4003V46.4008C34.6825 48.0016 35.9827 49.3008 37.5848 49.3008C39.1868 49.3008 40.4871 48.0016 40.4871 46.4008V17.4003C40.4871 15.7995 39.1868 14.5002 37.5848 14.5002C35.9827 14.5002 34.6825 15.7995 34.6825 17.4003Z",
    fill: "#AFB1BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodataimage);
export default __webpack_public_path__ + "static/media/nodataimage.6caf3f946fa7b110a2fea98dfc1793e5.svg";
export { ForwardRef as ReactComponent };